export default __webpack_public_path__ + "static/media/beverage.465c5cc8.png";